export const INITIALIZE_NOMINEE_ARRAY = 'INITIALIZE_NOMINEE_ARRAY';
export const UPDATE_NOMINEE_ARRAY = 'UPDATE_NOMINEE_ARRAY';
